import _find from 'lodash/find';
import { createSelector } from 'reselect';
import { services, scheduleIncrements } from 'store/saga/entities/bound';
import { selectActiveVenueId, selectRouteParams } from 'selectors/general';

export const selectServicesIsLoading = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => services.loading(state, venueId)
);

export const selectServices = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => (services.loaded(state, venueId) ? services.data(state, venueId) : [])
);

export const selectSelectedServiceId = createSelector(selectRouteParams, params => params.itemId);

export const selectSelectedService = createSelector(
  selectServices,
  selectSelectedServiceId,
  (srvs, serviceId) => _find(srvs, ({ id }) => id === serviceId) || {}
);

export const selectScheduleIncrementsIsLoading = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => scheduleIncrements.loading(state, venueId)
);

export const selectScheduleIncrements = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => (scheduleIncrements.loaded(state, venueId) ? scheduleIncrements.data(state, venueId) : [])
);
